import * as React from 'react';
const queryString = require('query-string');

import { FOfferType } from '../../../../../JsonQuery';
import { useContext } from '../../../utils/useContext';
import { useDealType } from '../../../utils/useDealType';
import { useOfferType } from '../../../utils/useOfferType';
import { OfferType } from '../../../components/filters/OfferType';

export const OfferTypeContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const dealType = useDealType();
  const offerType = useOfferType();
  const [commercialLink, setCommercialLink] = React.useState('#');

  const handleChange = React.useCallback(
    (offerType: FOfferType) => {
      onChange({ action: 'selectOfferType', arguments: [offerType] });
    },
    [onChange],
  );

  React.useEffect(() => {
    setCommercialLink(getCommercialLink());
  }, [jsonQuery]);

  return <OfferType dealType={dealType} value={offerType} commercialLink={commercialLink} onChange={handleChange} />;
};

function getCommercialLink(): string {
  if (typeof window === 'undefined') {
    return '#';
  }

  const parsedUrl = queryString.parseUrl(document.URL, {
    arrayFormat: 'index',
    parseNumbers: true,
    parseBooleans: true,
  });

  return [
    '/cat.php?engine_version=2&offer_type=offices&office_type%5B0%5D=1',
    parsedUrl.query['deal_type'] ? `deal_type=${parsedUrl.query['deal_type']}` : null,
    parsedUrl.query['region'] ? `region=${parsedUrl.query['region']}` : null,
  ]
    .filter(Boolean)
    .join('&');
}
